<template>
    <ion-app>
        <ion-router-outlet id="ionRouterOutlet" />
        <ImageViewer />
    </ion-app>
</template>

<script setup lang="ts">
import { ImageViewer } from "@/shared/lib/imageViewer"
import { getLanguage } from "@/shared/utils"
import { IonApp, IonRouterOutlet } from "@ionic/vue"
import { onMounted } from "vue"
import { useI18n } from "vue-i18n"

const { locale } = useI18n({ useScope: "global" })

onMounted(async() => {
    const savedLanguage = await getLanguage()
    if (savedLanguage)
        locale.value = savedLanguage
})
</script>
